export default {
    inject: ['container'],
    computed: {
        project () {
            return this.container.project
        }
    }
}
